export enum CarePlanActivityCode {
  Introduction = 'careplan.activity.code.introduction',
  HospitalQuestionnaire = 'careplan.activity.code.hospitalquestionnaire',
  MDTAppointments = 'careplan.activity.code.mdtappointments',
  SymptomsEnquiry = 'careplan.activity.code.symptomsenquiry',
  InterProfessionalServices = 'careplan.activity.code.interprofessionalservices',
  IndividualAssessment = 'careplan.activity.code.individualassessment',
  ContextualAssessment = 'careplan.activity.code.contextualassessment',
  Comments = 'careplan.activity.code.comments',
  Flag = 'careplan.activity.code.flag',
  OnboardingReview = 'careplan.activity.code.onboardingreview',
  QualityQuestionnaire = 'careplan.activity.code.qualityquestionnaire',
  FollowUp = 'careplan.activity.code.followup',
  DailyReview = 'careplan.activity.code.dailyreview',
  Escalation = 'careplan.activity.code.escalation',
}

export const CarePlanActivityCodeDisplay: Record<CarePlanActivityCode, string> =
  {
    [CarePlanActivityCode.Introduction]: 'Care Plan Introduction',
    [CarePlanActivityCode.HospitalQuestionnaire]: 'Hospital Questionnaire',
    [CarePlanActivityCode.MDTAppointments]: 'MDT Appointments',
    [CarePlanActivityCode.SymptomsEnquiry]: 'Symptoms Enquiry',
    [CarePlanActivityCode.InterProfessionalServices]:
      'Inter Professional Services',
    [CarePlanActivityCode.IndividualAssessment]: 'Individual Assessment',
    [CarePlanActivityCode.ContextualAssessment]: 'Contextual Assessment',
    [CarePlanActivityCode.Comments]: 'Comments',
    [CarePlanActivityCode.Flag]: 'Flag',
    [CarePlanActivityCode.OnboardingReview]: 'Onboarding Review',
    [CarePlanActivityCode.QualityQuestionnaire]: 'Quality Questionnaire',
    [CarePlanActivityCode.FollowUp]: 'Follow Up',
    [CarePlanActivityCode.DailyReview]: 'Daily Review',
    [CarePlanActivityCode.Escalation]: 'Escalation',
  };
